import Marquee from "react-fast-marquee";
import { Home } from "lucide-react";

const ITEMS = [
  "Adam's Way · Coming to Doylestown",
  "Inclusive Housing",
  "Community First",
  "Every Door Opens",
  "The Next Step Housing Corp",
];

const EditorialMarquee = () => (
  <section
    data-testid="editorial-marquee"
    className="border-y border-foreground/10 bg-secondary/40 py-6 overflow-hidden"
    aria-hidden="true"
  >
    <Marquee speed={28} gradient={false} pauseOnHover>
      {ITEMS.concat(ITEMS).map((item, i) => (
        <span key={i} className="flex items-center gap-12 pr-12">
          <span className="font-serif italic font-light text-2xl lg:text-3xl text-foreground/70 whitespace-nowrap">
            {item}
          </span>
          <Home size={18} className="text-primary shrink-0" />
        </span>
      ))}
    </Marquee>
  </section>
);

export default EditorialMarquee;
